module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("66GCL"))).then(() => parcelRequire('d0iPb'));